import { useEffect } from 'react';
import type { FieldValues, UseFormReset } from 'react-hook-form';

type TUseFlowSectionFormStateParams<TValues extends FieldValues> = {
  defaultValues: TValues;
  isDirty: boolean;
  isDisabled: boolean;
  onDirtyChange?: (isDirty: boolean) => void;
  requireChangesToEnableActions?: boolean;
  reset: UseFormReset<TValues>;
};

export const useFlowSectionFormState = <TValues extends FieldValues>({
  defaultValues,
  isDirty,
  isDisabled,
  onDirtyChange,
  requireChangesToEnableActions = false,
  reset,
}: TUseFlowSectionFormStateParams<TValues>) => {
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  useEffect(() => {
    onDirtyChange?.(isDirty);
  }, [isDirty, onDirtyChange]);

  return {
    isActionDisabled: isDisabled || (requireChangesToEnableActions && !isDirty),
  };
};
